import styled from "styled-components";


export const InfoContainer = styled.div`

	background: #F5F5F5 0% 0% no-repeat padding-box;
  opacity: 0.8;

	@media screen and (max-width: 768px) {
		padding: 0 0;
	}

`;
export const Swiper = styled.div`

	background: #F5F5F5 0% 0% no-repeat padding-box;
  opacity: 0.8;

	@media screen and (max-width: 768px) {
		padding: 0 0;
	}

`;

export const InfoWrapper = styled.div`
	display: grid;
	z-index: 1;
	/* height: 800px; */
	width: 100%;
	max-width: 1100px;
	margin-right: auto;
	margin-left: auto;
	justify-content: center;
  @media screen and (max-width: 480px) {
		padding: 0 0;
    height: 640px;
	}
  @media screen and (max-width: 768px) {
    height: 640px;
	}
`;

export const InfoRow = styled.div`
	display: grid;
	grid-auto-columns: minmax(auto, 1fr);
	grid-template-areas:  'col1 col2';

	@media screen and (max-width: 768px) {
		grid-template-areas:  'col1' 'col2';
	}
`;

export const Column1 = styled.div`
	margin-bottom: 15px;
	padding: 0 15px;
	grid-area: col1;
  margin-top: 70px;
  @media screen and (max-width: 768px) {
		justify-self: center;
    margin-bottom: 0;
    margin-top: 70px;
  
	}
`;

export const Column2 = styled.div`
	margin-bottom: 15px;
  margin-top: 300px;
	padding: 0 15px;
	grid-area: col2;
  @media screen and (max-width: 768px) {
		margin: 0;
    justify-self:center;
	}
  @media screen and (max-width: 480px) {
		margin-top: 3rem;
    justify-self:center;
	}
`;
export const TextWrapper = styled.div`
	max-width: 540px;
	padding-top: 0;

`;

export const TopLine = styled.p`
	color: #383838;
  max-width: 352px;
	line-height: 18px;
	font-weight: bold;
  font: normal normal 300 17px 'Spoqa Han Sans Neo';
	text-transform: capitalize;
	margin-bottom: 16px;
  text-align: left;
  letter-spacing: 0px;
  @media screen and (max-width: 480px){
		font-size: 14px;
	}
`;

export const Heading = styled.h1`
	margin-bottom: 24px;
	font: normal  normal bold 30px 'Spoqa Han Sans Neo';
	line-height: 1.1;
  width: 318px;
  color: #2783C6;
	@media screen and (max-width: 480px){
		font-size: 28px;
	}
`;

export const Subtitle = styled.p`
	max-width: 440px;
	font: normal normal 400 22px 'Spoqa Han Sans Neo';
	line-height: 15px;
  color: #000000;
  @media screen and (max-width: 480px){
		font-size: 16px;
	}
`;

export const Boldtitle = styled.p`
	max-width: 440px;
	margin-bottom: 25px;
  text-align: left;
  font:normal normal bold 22px 'Spoqa Han Sans Neo';
	line-height: 15px;
  color: #383838;
  @media screen and (max-width: 480px){
		font-size: 18px;
	}
`;



export const BtnWrap = styled.div`
	display: flex;
	justify-content: flex-start;
`;

export const ImgWrap =styled.div`
	max-width: 350px;
	height: auto;
`;

export const Img = styled.img`
	width: 350px;
  @media screen and (max-width: 480px){
		width: 300px;
	}
`;